var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlurredTenant',{attrs:{"showBlur":_vm.showBlur}},[(_vm.dataContainer.value)?_c('x-form',{attrs:{"x-options":_vm.formOptions,"x-container":_vm.formContainer,"x-data":_vm.dataContainer}}):_c('loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }